import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=c5a92374"
import script from "./Recipient.vue?vue&type=script&lang=js"
export * from "./Recipient.vue?vue&type=script&lang=js"
import style0 from "./Recipient.vue?vue&type=style&index=0&id=c5a92374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports